// extracted by mini-css-extract-plugin
module.exports = {"game":"snake_game__IRVJj","touch-controls":"snake_touch-controls__Rqnn0"};